<template>
  <div class="dashboard-card" v-if="rows.length > 1">
    <div class="card-header"><awesomeIcon icon="chart-area" /> Verloop van #{{$parent.port}}</div>
    <div class="card-graph">
      <GChart
        :settings="{ packages: ['corechart'], language: 'nl-nl' }"
        :data="rows"
        :options="options"
        :events="chartEvents"
        type="ComboChart"
      />
    </div>
    <div id="time-tooltip"></div>
  </div>
</template>

<script>
import { takeRight } from 'lodash-es';

export default {
  name: 'TimeWidget',
  data() {
    return {
      options: {
        tooltip: {
          trigger: 'none',
        },
        backgroundColor: { fill: 'transparent' },
        height: 300,
        colors: process.env.VUE_APP_STYLE === 'db' ? ['#6c0', '#006', '#f34b0a'] : this.$store.state.colorScheme,
        legend: {
          position: 'none',
        },
        pointSize: 7,
        chartArea: {
          left: 65,
          top: 25,
          bottom: 30,
          right: 20,
          width: '100%',
          height: '100%',
        },
        hAxis: {
          format: 'short',
          textStyle: { fontSize: 12 },
        },
        vAxis: {
          // format: '\'€\' ',
          gridlines: { color: '#eee' },
          textStyle: { fontSize: 13 },
        },
        series: {
          0: { type: 'area' },
          1: { type: 'bars' },
          2: this.$parent.currentPort.brand === 'Doelbeleggen'
            ? {}
            : { type: 'line', pointSize: 0, lineWidth: 0 }
          ,
        },
      },
      columns: [
        {
          type: 'string',
          label: 'Datum',
        },
        {
          type: 'number',
          label: 'Waarde',
        },
        {
          type: 'boolean',
          role: 'certainty',
        },
        {
          type: 'number',
          label: 'Stortingen',
        },
        {
          type: 'number',
          label: 'totalInvest',
        },
      ],
      chartEvents: {
        onmouseover: this.setTooltipContent,
        onmouseout: () => { this.setTooltipContent(null); },
      },
    };
  },
  computed: {
    rows() {
      return [this.columns].concat(takeRight(
        this.$parent.totals,
        10,
      ));
    },
  },
  methods: {
    setTooltipContent(object) {
      const tooltip = document.getElementById('time-tooltip');
      if (object !== null) {
        tooltip.style.display = 'block';
        tooltip.innerHTML = `Periode: ${this.rows[object.row + 1][0] || ''} - <span style="color:${this.options.colors[0]}">Waarde: € ${this.formatPrice(this.rows[object.row + 1][1]) || ''}</span> - <span style="color:${this.options.colors[1]}"> ${(this.rows[object.row + 1][3]) > 0 ? 'Stortingen: ' : 'Onttrekkingen: '} € ${this.formatPrice(Math.abs(this.rows[object.row + 1][3])) || ''} </span> ${
          this.$parent.currentPort.brand === 'Doelbeleggen'
            ? `<br> <span style="color:${this.options.colors[2]}">Totaal ingelegd € ${this.formatPrice(this.rows[object.row + 1][4]) || ''} </span>`
            : ''
        }`;
      } else {
        tooltip.style.display = 'none';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .card-graph {
    padding-bottom: 10px;
    min-height: 300px;
  }
  #time-tooltip {
    padding: 10px 20px;
    background-color: #fcf8e3;
    color: #8a6d3b;
    display: block;
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    display: none;
    pointer-events: none;
    border-radius: $br;
  }
</style>
